import React from 'react'

function Dummy() {
  return (
      <div className='text-6xl text-red-800 text-center items-center h-screen flex justify-center'>Still developing we will update soon</div>
  )
}

export default Dummy